import { MaterialReactTable } from "material-react-table";

export default function PavilionTable({ data, loading, onEdit, onDelete }) {
  const columns = [
    {
      accessorKey: "pavilion_name",
      header: "Pavilion Name",
    },
    {
      header: "Actions",
      Cell: ({ row }) => (
        <div className="flex gap-2">
          <button
            onClick={() => onEdit(row.original)}
            className="rounded bg-yellow-100 px-3 py-1 text-xs"
          >
            Edit
          </button>
          <button
            onClick={() => {
              if (
                window.confirm(
                  `Delete Pavilion "${row.original.pavilion_name}"?`
                )
              ) {
                onDelete(row.original);
              }
            }}
            className="rounded bg-red-100 px-3 py-1 text-xs"
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  return (
    <MaterialReactTable
      columns={columns}
      data={data}
      state={{ isLoading: loading }}
      enableExpanding
      getSubRows={(row) => row.children}
      enableColumnOrdering={false}
      enableSorting={false}
      enableColumnFilters={false}
      muiTableBodyRowProps={{ hover: true }}
      enableGlobalFilter={false}
    />
  );
}
